class PvtMegamenuItem extends HTMLElement {
  constructor() {
    super()
    this.$detail = this.querySelector('details')
    this.$trigger = this.$detail.querySelector('summary')
    this.$aside = this.querySelector('.pivot-megamenu-item__main-aside')
    this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems')
    this.$parent = this.closest('.shopify-section')
    this.openMode = this.dataset.openMode
    this.sidemenuBehavior = this.dataset.sidemenuBehavior
    this.isTouch = window.matchMedia('(hover:none)')

    // Cerrar el menu al esconder el header
    const observer = new MutationObserver(entries => {
      entries.forEach(entry => {
        if (!this.$detail.open) return
        const clss = this.$parent.getAttribute('class')
        if (clss === entry.oldValue) return
        this.$detail.open = !this.$parent.classList.contains(
          'shopify-section-header-hidden'
        )
      })
    })
    observer.observe(this.$parent, {
      attributeFilter: ['class'],
      attributes: true,
      attributeOldValue: true,
    })

    // Cerrar al clickear fuera
    this.addEventListener('click', e => {
      if (e.target === this) {
        this.$detail.open = false
      }
    })

    // Hover en los elementos internos
    const openMenu = e => {
      e.preventDefault()
      const $newMenuActive = e.target.closest('a')
      if (!$newMenuActive) return

      const $currentMenuActive = this.$aside.querySelector('.active')
      const $currentGridActive = this.$subItemsWrapper.querySelector('.active')

      if ($currentMenuActive) $currentMenuActive.classList.remove('active')
      if ($currentGridActive) $currentGridActive.classList.remove('active')

      $newMenuActive.classList.add('active')
      this.$subItemsWrapper
        .querySelector(`#${$newMenuActive.dataset.item}`)
        ?.classList.add('active')
    }
    this.$aside.addEventListener(
      this.sidemenuBehavior === 'navigate' && !this.isTouch.matches
        ? 'mouseover'
        : 'click',
      openMenu
    )
    // Hover en el trigger
    if (this.openMode === 'hover')
      this.$trigger.addEventListener('mouseover', () => {
        this.$detail.open = true
      })
  }
}
if (!customElements.get('pvt-megamenu-item')) {
  customElements.define('pvt-megamenu-item', PvtMegamenuItem)
}

